// extracted by mini-css-extract-plugin
export default {"page":"Setting_page__zByWE","item_frame":"Setting_item_frame__tVOtD"};